// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { OrderChangeRequestModel } from "@store/Framework/Types/ApiModels";

export interface GetOrderChangeRequestApiParameter extends ApiParameter {
    orderChangeRequestParameter: OrderChangeRequestModel;
}

export async function sendOrderChangeRequestEmail(
    parameter: GetOrderChangeRequestApiParameter,
): Promise<ServiceResult<OrderChangeRequestModel>> {
    try {
        const orderChangeRequestModel = await post<OrderChangeRequestModel>(
            `api/v1/custom/orderchangerequest/requestchange`,
            parameter.orderChangeRequestParameter,
        );
        return {
            successful: true,
            result: orderChangeRequestModel,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
